module.exports = __webpack_public_path__ + "img/telegram.d31f5b50.svg";